// extracted by mini-css-extract-plugin
module.exports = {"speNav":"speNav-3gIktXt3"};